import {
  SET_PROFILE_DATA,
  ADD_NEW_TENANT,
  DELETE_TENANT,
  DELETE_TENANT_DISMISS,
  DELETE_TENANT_PREVIEW,
  EDIT_TENANT,
  EDIT_TENANT_INIT,
  EDIT_TENANT_DISMISS,
  EDIT_TENANT_PREVIEW,
  SET_TENANT_DATA,
  PORTAL_TENANT_FETCHING_COMPLETE,
  PORTAL_TENANT_FETCHING_INIT,
  PORTAL_TENANT_FETCHING_DISMISS,
  ADD_NEW_TENANT_DISMISS,
  ADD_NEW_TENANT_PREVIEW,
  ADD_NEW_TENANT_INIT,
  CHANGE_PORTAL_PAGE,
  LOAD_COUNTRY_LIST,
  LOAD_DISTRIBUTOR_LIST,
  LOAD_LANGUAGE_INDUSTRY_LIST,
  LOAD_PARENT_COMPANY_LIST,
  LOAD_STATUS_LIST,
  LOAD_INVITE_PARTNER_OPTIONS,
  NORMAL_TENANT_FETCHING_INIT,
  NORMAL_TENANT_FETCHING_DISMISS,
  NORMAL_TENANT_FETCHING_COMPLETE,
  CHANGE_NORMAL_PAGE,
  SEARCH_PORTAL_TENANT,
  SEARCH_NORMAL_TENANT,
  ADD_NEW_TENANT_ERROR,
  EDIT_TENANT_ERROR,
  SET_PORTAL_SETTINGS_DATA,
  SET_ALL_ACTIVE_REPORT_TYPE,
  LOAD_CURRENCY_CODES,
  GET_NEW_PARTNERS_INIT,
  SEARCH_NEW_PARTNER,
} from "./types";
const initialState = {
  image_popup: false,
  tenant_list: [], //holds tenant list array
  tenantlist_fetching: false, //indicaction for fetch in progress
  portal_tenantlist_refetch: false, //indication to refetch current tenant list array
  portal_tenantlist_refetch_force: false, //indication to force refetch tenant list array from beginning
  normal_tenantlist_refetch: false, //indication to refetch current tenant list array
  normal_tenantlist_refetch_force: false, //indication to force refetch tenant list array from beginning
  edit_tenant: null, //holds initial data of tenant being edited
  delete_tenant: null, //holds initial data of tenant opted to be deleted
  disable_tenant: null, //holds initial data of tenant opted to be disabled,
  //PORTAL TENANT VARIABLES
  portal_page: 1, //page number on tenant listing
  perpage_portal_records: 20, //perpage limit on portal tenant listing
  portal_list_total_count: 0, //total records in portal_list
  portal_list: [],
  portal_search: "",
  //NORMAL TENANT VARIABLES
  normal_page: 1, //page number on tenant listing
  perpage_normal_records: 20, //perpage limit on portal tenant listing
  normal_list_total_count: 0, //total records in portal_list
  normal_list: [],
  normal_search: "",
  //property fileds
  countries: [], //countries list
  distributors: [], //distributors list
  languages: [], //languages list
  parent_companies: [], //parent_companies list
  status: [],
  invite_partner_options: [], // invite parner dropdown options
  cof: [],
  //Add tenant variables
  nT_sub_module_ids: [1],
  nT_org_type_id: 0,
  nT_role_id: 1,
  nT_country_operation_id: 0,

  nT_country_id: 0,
  nT_parent_org_id: 0,
  nT_language_id: 0,
  nT_org_name: "",
  nT_email: "",
  nT_phone_number: "",
  nT_parent_company: "",
  nT_parent_cmpny_status: true,
  nT_contact_person_name: "",
  nT_distributor_id: 0,
  nT_distributor_status: true,
  nT_service_charge: 1000,
  nT_cisco_discount_rate: 45,
  nT_comments: "",
  nT_status: "",
  nT_distributor: "",
  nT_cx_specialized: "none",
  //edit tenant variables
  eT_sub_module_ids: [1],
  eT_org_type_id: 0,
  eT_role_id: 1,
  eT_country_operation_id: 0,

  eT_country_id: 0,
  eT_parent_org_id: 0,
  eT_language_id: 0,
  eT_org_name: "",
  eT_email: "",
  eT_phone_number: "",
  eT_parent_company: "",
  eT_parent_cmpny_status: true,
  eT_contact_person_name: "",
  eT_distributor_id: 0,
  eT_distributor_status: true,
  eT_service_charge: 1000,
  eT_cisco_discount_rate: "",
  eT_comments: "",
  eT_status: "",
  componentStatus: "",
  eT_distributor: "",
  current_status: "",
  eT_accounts_field: "",
  eT_web_address: "",
  eT_comp_reg_no: "",
  eT_vat_no: "",
  eT_email_domain: "",
  eT_turnover: "",
  eT_employees: "",
  eT_classification: "",
  eT_industry: "",
  eT_vendor_accr: "",
  eT_user_limit: "",
  eT_reg_address: "",
  industry_list: [],
  eT_company_overview: "",
  eT_logo: "",
  eT_submit_btn_disable: false,
  eT_logo_state: "",
  profile_data_Refetch: false,
  eT_logo_upload_percentage: 0,
  eT_logo_upload_btn_disable: "",
  eT_interaction_level: "",
  eT_invoiced_user: false,
  eT_preferred_currency: "",
  currency_codes: [],
  eT_cx_specialized: " ",
  // submit btns
  add_tenant_btn_disable: false,
  edit_tenant_btn_disable: false,
  del_tenant_btn_disable: false,
  // Opts
  partner_opts: [],
  resend_popup: false,
  resend_enable: true,

  //portal settings
  eT_report_type_ids: [],

  //org name and overview
  eT_about_org_btn_disable: false,

  eT_userCount: "",

  //analytics
  analytics_start_date: "",
  analytics_end_date: "",
  eT_analytics_btn_disable: false,
  partner_analytics_start_date: "",
  eT_partner_analytics_btn_disable: false,
  partner_analytics_end_date: "",
  analyticsRoles: [],
  analyticsOrganisation: [],
  analyticsRolesSelected: "",
  analyticsOrganisationSelected: "",

  //Add Partner
  add_partner_button: true,

  //tenant_subscription
  userSubscription: [],
  isUserSubscriptionLoading: false,
  isUserSubscriptionModalOpen: false,
  SubscriptionSelected: {},
  sOrganisationList: [],
  sFilter: [],
  sPage: 1,
  sTotal: 0,
  sUserSubscriptionRefetch: false,
  sOrganisation: "",
  //partner walletBalance
  walletBalance: 0,
  et_subscription_user_unit: 0,

  //new partner admin notification(Partners(module) --> New Partner)
  new_partner_refetch: false,
  new_partner_refetch_search: false,
  new_partner_is_loading: false,
  new_partner_data: [],
  new_partner_current_page: 1,
  new_partner_page_limit: 20,
  new_partner_data_total_count: 0,
  new_partner_search: "",
  //portal access partner -> user-limit tab
  is_user_limit_loading: true,
  userLimitData: {},
  //portal access partner -> user-limit tab
  token_history_list: [],
  is_token_history_loading: false,

  selectedPartnerModule: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PROFILE_DATA:
      return { ...state, ...action.payload };
    case SET_TENANT_DATA:
      return { ...state, ...action.payload };
    case SET_PORTAL_SETTINGS_DATA:
      return { ...state, ...action.payload };
    case PORTAL_TENANT_FETCHING_INIT: {
      return {
        ...state,
        tenantlist_fetching: true,
        portal_tenantlist_refetch: false,
        portal_tenantlist_refetch_force: false,
      };
    }
    case PORTAL_TENANT_FETCHING_COMPLETE: {
      return {
        ...state,
        tenantlist_fetching: false,
        ...action.payload,
      };
    }
    case PORTAL_TENANT_FETCHING_DISMISS: {
      return { ...state, tenantlist_fetching: false };
    }
    case CHANGE_PORTAL_PAGE: {
      return {
        ...state,
        portal_tenantlist_refetch: true,
        portal_page: action.payload,
      };
    }
    case NORMAL_TENANT_FETCHING_INIT: {
      return {
        ...state,
        tenantlist_fetching: true,
        normal_tenantlist_refetch: false,
        normal_tenantlist_refetch_force: false,
      };
    }
    case NORMAL_TENANT_FETCHING_DISMISS: {
      return { ...state, tenantlist_fetching: false };
    }
    case NORMAL_TENANT_FETCHING_COMPLETE: {
      return { ...state, tenantlist_fetching: false, ...action.payload };
    }
    case CHANGE_NORMAL_PAGE: {
      return {
        ...state,
        normal_tenantlist_refetch: true,
        normal_page: action.payload,
      };
    }
    case LOAD_COUNTRY_LIST: {
      return { ...state, countries: action.payload };
    }
    case LOAD_DISTRIBUTOR_LIST: {
      return { ...state, distributors: action.payload };
    }
    case LOAD_LANGUAGE_INDUSTRY_LIST: {
      return { ...state, ...action.payload };
    }
    case LOAD_PARENT_COMPANY_LIST: {
      return { ...state, parent_companies: action.payload };
    }
    case LOAD_CURRENCY_CODES: {
      return { ...state, currency_codes: action.payload };
    }
    case LOAD_STATUS_LIST: {
      return { ...state, status: action.payload };
    }
    case LOAD_INVITE_PARTNER_OPTIONS: {
      return { ...state, invite_partner_options: action.payload };
    }
    case ADD_NEW_TENANT_INIT: {
      return { ...state, add_tenant_btn_disable: true };
    }
    case ADD_NEW_TENANT: {
      return {
        ...state,
        add_tenant_btn_disable: false,
        portal_tenantlist_refetch: true,
        normal_tenantlist_refetch: true,
        search: "",
        normal_page: 1,
        portal_page: 1,
      };
    }
    case ADD_NEW_TENANT_PREVIEW: {
      return {
        ...state,
        new_tenant_popup: true,

        nT_sub_module_ids: [1],
        nT_org_type_id: 0,
        nT_role_id: 1,
        nT_country_operation_id: 0,

        nT_country_id: 0,
        nT_parent_org_id: 0,
        nT_language_id: 0,
        nT_org_name: "",
        nT_email: "",
        nT_phone_number: "",
        nT_parent_company: "",
        nT_parent_cmpny_status: true,
        nT_contact_person_name: "",
        nT_distributor_id: 0,
        nT_distributor_status: true,
        nT_service_charge: 1000,
        nT_comments: "",
        nT_status: "",
        nT_distributor: "",
        nT_cisco_discount_rate: 45,
        nT_cx_specialized: "none",
      };
    }
    case ADD_NEW_TENANT_DISMISS: {
      return {
        ...state,
        new_tenant_popup: false,
        ...action.payload,
        add_tenant_btn_disable: false,
      };
    }
    case ADD_NEW_TENANT_ERROR: {
      return { ...state, add_tenant_btn_disable: false };
    }
    case EDIT_TENANT_PREVIEW: {
      return { ...state, edit_tenant_btn_disable: false, ...action.payload };
    }
    case EDIT_TENANT_INIT: {
      return { ...state, edit_tenant_btn_disable: true, ...action.payload };
    }
    case EDIT_TENANT: {
      return {
        ...state,
        portal_tenantlist_refetch: true,
        normal_tenantlist_refetch: true,
        search: "",
        normal_page: 1,
        portal_page: 1,
        edit_tenant_btn_disable: false,
      };
    }
    case EDIT_TENANT_DISMISS: {
      return { ...state, edit_tenant: null, edit_tenant_btn_disable: false };
    }
    case EDIT_TENANT_ERROR: {
      return { ...state, edit_tenant_btn_disable: false };
    }
    case DELETE_TENANT_PREVIEW: {
      return {
        ...state,
        del_btn_disable: false,
        delete_tenant: action.payload,
      };
    }
    case DELETE_TENANT: {
      return {
        ...state,
        delete_tenant: null,
        portal_tenantlist_refetch_force: true,
        normal_tenantlist_refetch_force: true,
        new_partner_refetch: true,
        del_btn_disable: false,
      };
    }
    case DELETE_TENANT_DISMISS: {
      return { ...state, delete_tenant: null };
    }
    case SEARCH_PORTAL_TENANT: {
      return {
        ...state,
        portal_tenantlist_refetch_force: true,
        portal_search: action.payload,
      };
    }
    case SEARCH_NORMAL_TENANT: {
      return {
        ...state,
        normal_tenantlist_refetch_force: true,
        normal_search: action.payload,
      };
    }
    case SEARCH_NEW_PARTNER: {
      return {
        ...state,
        new_partner_refetch_search: true,
        new_partner_search: action.payload,
      };
    }
    case SET_ALL_ACTIVE_REPORT_TYPE:
      return { ...state, ...action.payload };

    case GET_NEW_PARTNERS_INIT:
      return {
        ...state,
        new_partner_is_loading: true,
      };

    default:
      return state;
  }
};
